/* ZYMA RTL helper — loaded only for the ar locale (layout/theme.liquid).
   Copy that has no Arabic translation yet is still English. Inside dir="rtl" its trailing punctuation
   and leading numbers jump to the wrong end ("?right for you", "bottle 1"). Text elements that contain
   Latin letters and no Arabic get .zyma-latin (unicode-bidi: plaintext) so they keep their own reading
   order, plus an alignment class so they stay aligned with the RTL layout. Arabic lines that merely
   start with a brand name ("Zymaslim هو …") contain Arabic and are left alone. */
(() => {
  'use strict';

  if (document.documentElement.dir !== 'rtl') return;

  const ARABIC = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
  const LATIN = /[A-Za-z]/;
  const SELECTOR = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'li', 'dt', 'dd', 'summary', 'legend', 'label', 'figcaption', 'blockquote', 'button',
    '[class*="__name"]', '[class*="__meta"]', '[class*="__title"]', '[class*="__label"]'
  ].join(',');

  const mark = (root) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const nodes = scope instanceof Element && scope.matches(SELECTOR) ? [scope, ...scope.querySelectorAll(SELECTOR)] : [...scope.querySelectorAll(SELECTOR)];
    nodes.forEach((element) => {
      const text = element.textContent || '';
      const latinOnly = LATIN.test(text) && !ARABIC.test(text);
      if (!latinOnly) {
        element.classList.remove('zyma-latin', 'zyma-latin--start', 'zyma-latin--end');
        return;
      }
      if (element.classList.contains('zyma-latin')) return;
      const align = getComputedStyle(element).textAlign;
      element.classList.add('zyma-latin');
      if (align === 'start' || align === 'right') element.classList.add('zyma-latin--start');
      else if (align === 'end' || align === 'left') element.classList.add('zyma-latin--end');
    });
  };

  let pending = new Set();
  let frame = 0;
  const queue = (node) => {
    pending.add(node);
    if (frame) return;
    frame = window.setTimeout(() => {
      const nodes = pending;
      pending = new Set();
      frame = 0;
      nodes.forEach((item) => { if (item.isConnected) mark(item); });
    }, 120);
  };

  const start = () => {
    mark(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        const target = record.type === 'characterData' ? record.target.parentElement : record.target;
        if (target instanceof Element) queue(target.closest(SELECTOR) || target);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
